import { type ChangeEvent, type MouseEvent } from 'react';

import Button from '../../../juristec-ui/core/Button';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';

import { compactString } from '../../../juristec-ui/utils/functions/formatString';
import { verifyEmail } from '../../../juristec-ui/utils/validators/inputTextValidators';
import type { EmailDefaultProps } from '../types';

import {
  FormFieldSet,
  FormField,
  MiniLabel,
  HiddenInput,
} from '../styled';

const EmailDefault = ({
  emailState, passwordState, afterEmailPassword, afterEmailProvider, t,
}: EmailDefaultProps) => {
  const [email, setEmail] = emailState;
  const [password, setPassword] = passwordState;

  const emailHandle = (val: string) => {
    const msg = verifyEmail(val, true);
    setEmail({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const passwordHandle = (val: string) => {
    setPassword({
      value: val,
      error: false,
      errorMsg: '',
    });
  };

  const passwordEvent = (e: ChangeEvent<HTMLInputElement>) => {
    passwordHandle(compactString(e.target.value));
  };

  const emailEvent = (e: ChangeEvent<HTMLInputElement>) => {
    emailHandle(compactString(e.target.value));
  };

  const goTo = (e: MouseEvent<HTMLButtonElement>, callback: () => void) => {
    e.preventDefault();
    if (email.error) emailHandle(email.value);
    else callback();
  };

  const goToPassword = (e: MouseEvent<HTMLButtonElement>) => goTo(e, afterEmailPassword);

  const goToProvider = (e: MouseEvent<HTMLButtonElement>) => goTo(e, afterEmailProvider);

  return (
    <FormFieldSet>
      <h2>{t('loginTitle')}</h2>
      <FormField>
        <InputTextLine
          label={t('emailLabel')}
          type="email"
          name="email"
          value={email.value}
          errorMessage={email.errorMsg}
          error={email.errorMsg.length > 0}
          notTransparent={false}
          onChange={emailEvent}
          setValue={() => {}}
          autoComplete="username"
          autoFocus
        />
      </FormField>
      <HiddenInput
        type="password"
        name="password"
        autoComplete="current-password"
        value={password.value}
        onChange={passwordEvent}
      />
      <FormField style={{ margin: '20px 0 0 0' }}>
        <Button
          type="submit"
          onClick={goToPassword}
          textTransform="none"
          color="primary"
          size="large"
          style={{ width: '100%', margin: '0' }}
        >
          {t('continuePasswordBtn')}
        </Button>
      </FormField>
      {process.env.REACT_APP_FIREBASE_PROJECT_LABEL !== 'legalone-analytics' && (
        <>
          <MiniLabel>
            {t('orLabel')}
          </MiniLabel>
          <FormField>
            <Button
              type="button"
              onClick={goToProvider}
              textTransform="none"
              color="primary"
              size="large"
              style={{ width: '100%', margin: '0' }}
            >
              {t('continueSSOBtn')}
            </Button>
          </FormField>
        </>
      )}
    </FormFieldSet>
  );
};

export default EmailDefault;
